import { useSyncExternalStore } from 'react';
import { getViewingAs, subscribeViewingAs } from '../lib/viewingAs';

// React view of the viewing-as store in src/lib/viewingAs.js.
//
// useSyncExternalStore rather than useState + useEffect: the store is written
// from outside React (the AdminPanel click handler, and — once panels migrate
// in later phases — potentially anywhere), and this is the API that keeps
// every subscriber consistent without a Provider or a re-render race.
//
// The same function serves as the server snapshot. This app is client-rendered
// (CRA, no SSR) so that path is unreachable in practice, but omitting it makes
// the hook throw under any renderer that does look for it, which is a needless
// sharp edge on a hook meant to be called from anywhere.
//
// Returns { viewingAsClientId, viewingAsClientName } — both null when the
// admin is themselves, which is the normal case for every non-admin session.
export function useViewingAs() {
  return useSyncExternalStore(subscribeViewingAs, getViewingAs, getViewingAs);
}

export { setViewingAs, clearViewingAs } from '../lib/viewingAs';
